import React from 'react';
import Button, { ButtonProps } from '@material-ui/core/Button';
import { Loader } from '../Loader';

interface Props extends ButtonProps {
  loading?: boolean;
}

export const EnhancedButton: React.FC<Props> = ({
  children,
  loading = false,
  disabled = false,
  ...btnProps
}: Props) => {
  return (
    <Button disabled={disabled || loading} {...btnProps}>
      {loading ? <Loader size={26} /> : children}
    </Button>
  );
};
